import type { TFunction } from "i18next";
import type { Order } from "../../api/orders";

/**
 * Where an approved order stands in the ERP, by its documents: the pro forma invoice and, with deferred payment, the
 * customer's order the portal makes from it, which production works from. With an advance the customer's order waits
 * for the money.
 */
export function approvedHint(t: TFunction, order: Order): string {
  if (!order.erpProformaNumber) {
    return t("orderErp.approvedPending", "Approved; it is being written to the ERP.");
  }
  if (order.erpCustomerOrderNumber) {
    return t("orderErp.approvedWithOrder", {
      proforma: order.erpProformaNumber,
      customerOrder: order.erpCustomerOrderNumber,
      defaultValue: "Approved and in the ERP: pro forma invoice {{proforma}} and customer's order {{customerOrder}}, which production works from. Next is the dispatch order, on which quality picks the lot.",
    });
  }
  return t("orderErp.approvedAdvance", {
    proforma: order.erpProformaNumber,
    defaultValue: "Approved and in the ERP: pro forma invoice {{proforma}}. Paid in advance, so the customer's order is made once the advance is paid.",
  });
}
